import styled from 'styled-components';
import { space, SpaceProps, width, WidthProps, height, HeightProps, color, ColorProps } from 'styled-system';

export const Delimiter = styled.div<SpaceProps & WidthProps & HeightProps & ColorProps>`
  ${space};
  ${width};
  ${height};
  ${color};
`;
Delimiter.defaultProps = {
  height: '1px',
  bg: 'iceBlueTwo'
};

export default Delimiter;
